enum MessageSenderType {
    Tenant,
    Customer,
}

export default MessageSenderType;
